import styles from './LandingPage.module.scss';
import { useTranslation } from 'react-i18next';
import { VdsButton } from '@volt/volt-extended-components-react';
import { useCallback } from 'react';
import { useAppDispatch } from '@customer/store/hooks';
import { login } from '@customer/store/slices/authSlice';
import logo from '@cas/assets/wabtec-logo-white.svg';
import { ExternalUrl } from '@cas/config/links';

export function LandingPage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onLogin = useCallback(() => {
    dispatch(login());
  }, [dispatch]);

  return (
    <article className={styles.landingPage}>
      <div className={styles.container}>
        <header className={styles.header}>
          <img className={styles.logo} src={logo} alt={t('WabtecLogo')} />
        </header>

        <div className={styles.content}>
          <div className={styles.heading}>
            <div className={styles.heading__title}>{t('LandingTitle')}</div>
            <div className={styles.heading__subhead}>{t('Digital Mine Portal')}</div>
          </div>
          <div className={styles.actions}>
            <VdsButton
              id="sign-in-button"
              variant="primary"
              size="large"
              danger
              onClick={onLogin}
              isFullWidth
            >
              {t('SignIn')}
            </VdsButton>
            <div className={styles.requestAccess}>
              {t('NotACustomer')}
              <a
                className={styles.requestAccess__link}
                href={ExternalUrl.MiningContact}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('RequestAccess')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default LandingPage;
